export type NotificationMessages = { [app: string]: string[] }

const messages = (value: unknown): value is NotificationMessages => !!value && typeof value === 'object' && !Array.isArray(value)
  && Object.values(value).every(list => Array.isArray(list) && list.every(text => typeof text === 'string'))

// soft() uses the original one-argument packet; confirm() includes its ID.
// Validate the complete batch before displaying or acknowledging any of it.
export function decodeNotificationPacket(first: unknown, second?: unknown) {
  if (second === undefined && messages(first)) return { msg: first, id: undefined }
  if ((typeof first === 'string' || first == null) && messages(second)) return { msg: second, id: typeof first === 'string' && first ? first : undefined }
  return undefined
}
